module.exports = __webpack_public_path__ + "static/media/CircularPro-BookItalic.1c0a2584.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-BookItalic.woff
// module id = 115
// module chunks = 0